<template>
  <div class="content-v2">
    <div class="honors-grid-v2">
      <div class="honor-card" v-for="item in honorList" :key="item.id">
        <div class="honor-img">
          <img :src="item.image" :alt="item.name" />
        </div>
        <p>{{ item.name }}</p>
        <span v-if="item.issuer || item.date">{{ item.issuer }} {{ item.date }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getHonorList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultHonorImage from '@/assets/images/case1.svg'

export default {
  name: 'AboutHonorsV2',
  data() {
    return {
      honorList: Array.from({ length: 8 }).map((_, index) => ({
        id: index + 1,
        name: [
          '安全生产许可证',
          '承装（修、试）电力设施许可证',
          '电力工程调试企业能力评价等级证书',
          'CNAS检验检测认证',
          '售电业务许可证',
          '质量管理体系认证证书',
          '企业信用等级AAA级证书',
          '国家级高新技术企业'
        ][index],
        image: defaultHonorImage,
        issuer: '',
        date: ''
      }))
    }
  },
  created() {
    getHonorList({ pageNum: 1, pageSize: 50 }).then(list => {
      if (!list || !list.length) {
        return
      }
      this.honorList = list.map(item => ({
        id: item.honorId,
        name: item.honorName,
        image: resolveFileUrl(item.imageUrl, defaultHonorImage),
        issuer: item.issuer || '',
        date: item.honorDate || ''
      }))
    }).catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
.honors-grid-v2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.honor-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 8px 30px rgba(0,0,0,0.08);
  }

  .honor-img {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 12px;

    img {
      width: 100%;
      display: block;
    }
  }

  p {
    font-size: 14px;
    color: #475569;
  }

  span {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #94a3b8;
  }
}

@media (max-width: 960px) {
  .honors-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
